// ─── src/utils/cleanText.js ───────────────────────────────────────────────────
// Aura's copy must never show an em dash. It's a house rule and a known AI tell,
// and the model ignores the prompt instruction often enough that we strip it
// deterministically at the point of DISPLAY, the last line of defence, whatever
// the backend produced. Renders only; underlying data is untouched.
export function cleanDashes(text) {
  if (typeof text !== 'string' || !text) return text;
  return text
    .replace(/\s*—\s*/g, ', ')     // em dash (U+2014) used as a break → comma
    .replace(/\s+--\s+/g, ', ')    // ascii "word -- word" → comma
    .replace(/^\s*,\s*/, '')       // drop a leading comma if a dash opened the line
    .replace(/\s*,\s*,/g, ',')     // collapse any accidental double comma
    .replace(/\s+([,.])/g, '$1');  // no space before the punctuation we introduced
}
